<div class="row" style="min-height: 100px">
  <div class="card">


    <div class="card-body">

      <form [formGroup]="merchatstatusform" (ngSubmit)="merchantStatusChange(merchatstatusform.value)">


        <div class="row">

          <div class="col-sm-12">
            <div class="mb-12">
              <label class="form-label">Merchant Status <span aria-hidden="true"
                class="symbol required"
                style="color:red;">*</span></label>
              <!-- <input type="text" autocomplete="new-password" formControlName="Status"> -->
              <select class="form-select" aria-label="Default select example" formControlName="Status" placeholder="Select Merchant Status"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.Status.errors}">
                      <option value="null" [disabled]="true" >Select Merchant Status</option>
                      <option value="ACTIVE" *ngIf="status !== 'ACTIVE'">Activate</option>
                      <option value="BLOCKED" *ngIf="status !== 'BLOCKED'">Block</option>
                      <option value="CLOSED" *ngIf="status !== 'CLOSED'">Close</option>
                      <option value="SUSPENDED" *ngIf="status !== 'SUSPENDED'">Suspend</option>
                      <option value="RESUBMIT" *ngIf="status !== 'RESUBMIT'">Resubmit</option>
                <!-- <option [selected]="true"  value="" selected disabled>Select Merchant Status</option> -->
                <!-- <option *ngFor="let merchantstatuslist of Resdata" [value]="merchantstatuslist.FieldValue">
                  {{merchantstatuslist.FieldText}}</option> -->
              </select>
              <div *ngIf="isForm1Submitted && form1.Status.errors?.required" class="invalid-feedback">
                Please fill this field
              </div>
              <div *ngIf="form1.Status.value === 'CLOSED'" class="text-danger mt-1">
                <strong>Warning:</strong> Closing this merchant is permanent and cannot be undone or reverted back.
              </div>
              <div *ngIf="status === 'CLOSED'" class="text-danger mt-1">
                <strong>Note:</strong> This merchant is permanently closed and its status can no longer be changed.
              </div>


            </div>
          </div>
        </div>

        <div class="row">

          <!-- <div class="col-sm-12">
            <div class="mb-12">
              <label class="form-label">Merchant Segment</label> -->
              <!-- <input type="text" autocomplete="new-password" formControlName="Status"> -->
              <!-- <select class="form-select" aria-label="Default select example" formControlName="Segment" placeholder="Select Merchant Status"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.Segment.errors}">
                      <option [ngValue]="null" [disabled]="true" >Select Segment</option> -->

                <!-- <option [selected]="true"  value="" selected disabled>Select Merchant Status</option> -->
                <!-- <option *ngFor="let merchantsegment of segmentData" [value]="merchantsegment.segment">
                  {{merchantsegment.segment}}</option>
              </select>
              <div *ngIf="isForm1Submitted && form1.Segment.errors?.required" class="invalid-feedback">
                Please fill this field
              </div>


            </div> -->
          <!-- </div> -->
        </div>


        <div class="row mt-2">
          <div class="col-sm-12">
            <label for="exampleFormControlTextarea1">Comment <span aria-hidden="true"
              class="symbol required"
              style="color:red;">*</span></label>
            <textarea class="form-control" rows="3" formControlName="Remark"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.Remark.errors}" maxlength="200"></textarea>
            <div *ngIf="isForm1Submitted && form1.Remark.errors?.required" class="invalid-feedback">
              Please fill this field
            </div>
            <div *ngIf="isForm1Submitted && form1.Remark.errors?.twoSpaces" class="invalid-feedback">
              More than two consecutive spaces are not allowed
            </div>
          </div>
        </div>


        <div class="row mt-3 ">
          <div class="col-md-4">
            <button type="submit" class="btn btn-lg btn-primary"
            [disabled]="this.loading || status === 'CLOSED'">
              <span  id="loading" role="status" aria-hidden="true"></span>
              Submit</button>
          </div>
        </div>


      </form>


      <!-- <div class="row" [style.display]="this.remarkData && this.remarkData[0]!=='Not Found Data' ? 'block' : 'none'">
         <div class="row" [style.display]="this.remarkData">
          <div class="col-md-12 stretch-card">
            <div class="card">
              <div class="card-body">
                <h6 class="card-title">Status Remark List</h6>
                <div class="table-responsive">
                  <button type="button" (click)="exportexcel()" class="btn btn-light">Export CSV<i  class="feather icon-download"></i></button>
                  <table id="dataTableExample" class="table">
                     <table  class="table">
                    <thead>
                    <tr>
                      <th>Added By</th>
                      <th style="min-width:50px;">Remark</th>
                      <th>Added On</th>
                      <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    </tbody>
                    <tfoot>
                      <tr >
                       <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                       <th></th>
                      <th></th>



                      <th>{{list.remark}}</th>
                      <th>{{list.addedOn}}</th>

                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="row" style="min-height: 300px">
          <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
            <ag-grid-angular
                             [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
                             [paginationPageSize]="pageSize" [pagination]="true" [rowData]="remarkData"
                             [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
                             style="width: 100%; height: auto;"></ag-grid-angular>
          </div>
      </div>

    </div>
  </div>
</div>

